"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FunctionalSplit = void 0;
var _SVG = require("../SVG");
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const FunctionalSplit = _ref => {
  let {
    color = "#3667E9",
    strokeWidth = 2,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_SVG.SVG, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/_react.default.createElement("path", {
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: strokeWidth,
    d: "M15 3h5m0 0v5m0-5-6.52 6.927A5 5 0 0 1 9.84 11.5H3.5M20 15v5m0 0h-5m5 0-6-6"
  }));
};
exports.FunctionalSplit = FunctionalSplit;
FunctionalSplit.displayName = "FunctionalSplit";